module.exports = __webpack_public_path__ + "static/media/product_information.1a54d599.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/product_information.svg
// module id = 1094
// module chunks = 36